<div class="box-layout">
  <div class="box-wrapper">
    <router-outlet></router-outlet>
  </div>
</div>
